<template>
  <el-container id="app">
    <el-aside width="200px">
      <el-header >
        <p class="title">菜狗后台管理系统</p>
      </el-header>
      <el-menu
        default-active="/statistics"
        class="el-menu-vertical-demo"
        background-color="#fff"
        text-color="#303133"
        active-text-color="#303133"
        unique-opened
        router>
        <el-menu-item index="/statistics">综合统计</el-menu-item>
        <el-menu-item index="/bill" >人员管理</el-menu-item>
        <el-menu-item index="/merchant" >商户管理</el-menu-item>
        <!--<el-menu-item index="/dict" >字典管理</el-menu-item>-->
        <el-menu-item index="/edition" >版本管理</el-menu-item>
        <el-menu-item index="/notice" >公告管理</el-menu-item>
        <el-menu-item index="/opinion" >意见反馈</el-menu-item>



      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="header-flex">
          <el-button type="primary" class="goOut" @click="goOut">退出登录</el-button>

        </div>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  export default {
    name: "index",
    data(){
      return{
        uname:'张三'
      }
    },
    mounted(){

    },
    methods:{
      goOut(){
        this.$router.push('/login')
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
      },
    }
  }
</script>

<style scoped>
  .el-main {
    background-color: #F2F7FA;
    color: #333;
  }
  .el-aside{
    background-color: #fff;
    color: #333;
    overflow: auto;
    box-sizing: border-box;
    flex-shrink: 0;
  }


  .el-menu{
    border-right: 0 !important;
    overflow: hidden;
  }
  .title{
    font-size: 18px;
    line-height: 60px;
    box-sizing: border-box;
  }
  #app{
    height: 100%;
  }
  .header-flex{
    padding-top: 10px;
  }
  .goOut{
    float: right;
  }
  .header{
    background-color: #fff;
    border-bottom:  solid 1px #e6e6e6;

  }
  .user{
    float: right;
    line-height: 40px;
    margin-right: 30px;
  }
  .is-active{
    color: rgb(22, 132, 252) !important;
    background-color: rgb(230, 247, 255) !important;
  }
  .el-main {
    background-color: #E9EEF3;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue